/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { State } from '@core/store';
import * as  CustomersActions from '@customers/store/customers.actions';
import { getCustomersPartial, isActionPending } from '@customers/store/customers.selectors';
import { Store } from '@ngrx/store';
import { Customer } from '@shared/models';
import { Observable, of, Subscription } from 'rxjs';
import { debounceTime, map, tap } from 'rxjs/operators';

const isObject = (value: unknown): value is object => value !== null && typeof value === 'object';

@Component({
    selector: 'app-customer-search',
    templateUrl: './customer-search.component.html',
    styleUrls: ['./customer-search.component.scss'],
    standalone: false
})
export class CustomerSearchComponent implements OnInit, OnDestroy {
  @Input() control = new UntypedFormControl();
  filteredCustomers$: Observable<Customer[]>;
  actionPending$: Observable<boolean>;
  private searchString: string;
  private searchText = '';
  private controlSubscription: Subscription;
  private acResultSubscription: Subscription;

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.actionPending$ = this.store.select(isActionPending);

    this.controlSubscription = this.control.valueChanges.pipe(
      debounceTime(300),
      tap(searchText => {
        if (searchText.toString().length >= 3) {
          this.searchText = searchText;
          this.searchForCustomerStartingWith(searchText);
        }
      }),
    ).subscribe();

    this.acResultSubscription = this.store.select(getCustomersPartial).pipe(
      tap(customers => {
        if (customers.length === 1) {
          this.control.setValue(customers[0]);
        }
      })
    ).subscribe(customers => this.filteredCustomers$ = of(customers));

    this.control.valueChanges.subscribe(() => {
      if (this.control.valid && isObject(this.control.value)) {
        this.control.parent.get('constructionSite').enable();
      } else {
        this.control.parent.get('constructionSite').patchValue('');
        this.control.parent.get('constructionSite').disable();
      }
    });
  }

  displayCustomer(customer?: Customer): string {
    return customer ? customer.code : '';
  }

  private searchForCustomerStartingWith(searchText: string): void {
    this.searchString = searchText;
    this.store.dispatch(new CustomersActions.LoadCustomersPartial(searchText));
  }

  ngOnDestroy(): void {
    this.acResultSubscription.unsubscribe();
    this.controlSubscription.unsubscribe();
  }
}
